import React from 'react'
import styles from './styles.css'
import AttributedHtmlText from '#src/components/AttributedHtmlText'
import { MetaDataComponentProps } from '../../MetaData'

const GenericInfoBoxPageMetadata: React.SFC<MetaDataComponentProps> = ({ metaData }) => {
  const body =
    metaData && metaData.__typename === 'GenericInfoBoxPageMetadata' ? metaData.body : null

  return body ? (
    <div className={styles.row}>
      <div className={styles.copy}>
        <AttributedHtmlText text={body} />
      </div>
    </div>
  ) : null
}

export default GenericInfoBoxPageMetadata
